import React from 'react'
const DoubleLineList = () => (
  <ul className="list-group">
    <li className="list-group-item list-group-item-action active">
      <p className="list-group-item-heading">List group item heading</p>
      <p className="list-group-item-text">Some text</p>
    </li>
    <li className="list-group-item list-group-item-action">
      <p className="list-group-item-heading">List group item heading</p>
      <p className="list-group-item-text">Some text</p>
    </li>
    <li className="list-group-item list-group-item-action">
      <p className="list-group-item-heading">List group item heading</p>
      <p className="list-group-item-text">Some text</p>
    </li>
  </ul>
)
export default DoubleLineList



// WEBPACK FOOTER //
// ./src/ui-elements/lists/DoubleLineList.js